import React, { useEffect, useState } from 'react';

// Styles & Assets
import styles from './DialogSelectEpisode.module.css';

// Services
import { getEnvironmentApiUrl } from '../../../services/General';

// Hooks
import { useTranslation } from 'react-i18next';
import useHttp from '../../../hooks/useHttp';
import { useNavigate } from 'react-router-dom';

// Components
import CancelConfirmButtons from '../../UI/CancelConfirmButtons/CancelConfirmButtons';
import Table from '../../UI/Table/Table';
import ErrorSpinnerWrapper from '../../UI/ErrorSpinnerWrapper.tsx/ErrorSpinnerWrapper';

// Other 
import moment from 'moment';

// Models
import { Column } from '../../../interfaces/Columns';
import { Case } from '../../../interfaces/Patient';
import EnvironmentsString from '../../Helpers/EnvironmentsString';
import usePatientStore from '../../../stores/patient-store';
interface Props {
    currentCaseID: number | null
    closeModal: () => void
}

const DialogSelectEpisode: React.FC<Props> = ({ currentCaseID, closeModal }) => {

    const { t } = useTranslation();

    const navigate = useNavigate();

    const patient = usePatientStore(state => state.patient);
    const patientID = patient?.id ?? null;

    const [selectedCaseID, setSelectedCaseID] = useState(currentCaseID);

    const { isLoading, error, sendRequest } = useHttp<Case[]>();

    const [cases, setCases] = useState<Case[]>([]);

    useEffect(() => {
        if (patientID === null) return;
        sendRequest({
            url: getEnvironmentApiUrl() + `patient/${patientID}/cases`
        }, (data) => setCases(data))
    }, [patientID, sendRequest]);

    const COLUMNS_EPISODE: Column<Case>[] = [
        {
            id: 0,
            name: () => '',
            visible: true,
            sortable: false,
            element: (caso) =>
                <input type='radio'
                    checked={caso.id === selectedCaseID}
                    readOnly
                />
        },
        {
            id: 1,
            name: () => t('case'),
            classHeader: styles.headerTable,
            classBody: styles.cellTable,
            visible: true,
            sortable: true,
            cell: (caso) => caso.hospital_case ?? '-',
        },
        {
            id: 2,
            name: () => t('service'),
            classHeader: styles.headerTable,
            classBody: styles.cellTable,
            visible: true,
            sortable: true,
            element: (caso) => <EnvironmentsString profileIDs={[caso.profile_id]} />,
        },
        {
            id: 3,
            name: () => t('start_date'),
            classHeader: styles.headerTable,
            classBody: styles.cellTable,
            visible: true,
            sortable: true,
            cell: (caso) => caso.start_date ? moment(caso.start_date).format('DD/MM/YYYY') : '-',
        },
        {
            id: 4,
            name: () => t('end_date'),
            classHeader: styles.headerTable,
            classBody: styles.cellTable,
            visible: true,
            sortable: true,
            cell: (caso) => caso.end_date ? moment(caso.end_date).format('DD/MM/YYYY') : '-',
        },
    ];

    const handleConfirm = () => {
        if (selectedCaseID === null) return;
        closeModal();
        navigate(`/home/patients/cases/${selectedCaseID}`);
    }

    return (
        <div className='dialog'>
            <h1 className='dialogTitle' style={{ marginBottom: '1rem' }}>
                {t('episode_selection')}
            </h1>
            <ErrorSpinnerWrapper loading={isLoading} error={error}>
                <Table
                    rows={cases}
                    columns={COLUMNS_EPISODE}
                    onClickRow={(id) => setSelectedCaseID(id)}
                />
            </ErrorSpinnerWrapper>
            <CancelConfirmButtons
                onCancel={closeModal}
                onConfirm={handleConfirm}
            />
        </div>
    );
};

export default DialogSelectEpisode;